// extracted by mini-css-extract-plugin
export default {"full-overlay":"errorLayout_full-overlay__VV7no","centered-column":"errorLayout_centered-column__ZQmuG"};